'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';

const FileIsNotAnImageError = ({
  filename
}) => /*#__PURE__*/_jsx("div", {
  className: "m-bottom-2",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "FileManagerLib.notifications.upload.expectedImage.message",
    options: {
      filename
    }
  })
});

export default FileIsNotAnImageError;